import { createSlice } from '@reduxjs/toolkit'
import { listUIReducers } from '../reducers'
import { listUIInitialState } from '@utils/constants/requestConstants'
import { directoryReducers } from '../reducers'

const publishedCompaniesListSlice = createSlice({
    name: 'ui/published-companies-list',
    initialState: {
        ...listUIInitialState,
        searchType: 'elastic',
        expandedContactKeys: [],
        expandedContactTreeKeys: [],
        expandedRowKeys: [],
        filters: { ...listUIInitialState.filters },
        openSideFilter: false,
        pureFilters: { ...listUIInitialState.pureFilters },
        populates: [
            { path: 'contacts', select: 'tel email' },
            { path: 'country', select: 'name' }
        ],
        excluded: {}
    },
    reducers: {
        ...listUIReducers,
        onResetFilters(state) {
            state.filters = { userType: 'all' }
            state.pureFilters = { userType: 'all' }
        },
        changeSideFilterVisibility(state, action) {
            state.openSideFilter = action.payload
        },
        onChangeCount(state, action) {
            state.count = action.payload
        },
        onChangeCountStatus(state, action) {
            state.status = action.payload
        },
        ...directoryReducers
    }
})

export const publishedCompaniesListActions = publishedCompaniesListSlice.actions
export default publishedCompaniesListSlice.reducer
